import React from 'react';
import { AvailableTo } from './AvailableTo/AvailableTo';
import { ScopedInstanceMember } from '../shared/interfaces/scopeInstanceMember.interface';

export interface IScopePermissionPicker {
  scopedMembers: ScopedInstanceMember[] | string;
  trigger?: React.ReactNode;
  maxWidth?: number;
}

// Kept as the entry point the Available To columns already import. The rendering
// lives in AvailableTo so any other scoping surface can reuse it. #34542
export const ScopePermissionPeopleComponent = (data: IScopePermissionPicker) => (
  <AvailableTo scopedMembers={data.scopedMembers} trigger={data.trigger} maxWidth={data.maxWidth} />
);
